import { render, staticRenderFns } from "./UploadInfo.vue?vue&type=template&id=5b64b9c4&"
import script from "./UploadInfo.vue?vue&type=script&lang=js&"
export * from "./UploadInfo.vue?vue&type=script&lang=js&"
import style0 from "./UploadInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports